import { CheckboxChangeEvent } from 'antd/es/checkbox';
import React, { FC } from 'react';
import { FieldWithValue } from 'api/tasks';
import { Checkbox } from 'components/atoms/checkbox';

interface Props {
  field: FieldWithValue;
  onChange: (selected: boolean, field: FieldWithValue) => void;
}
export const CheckboxField: FC<Props> = ({ field, onChange }) => {
  const handleOnChange = ({ target: { checked } }: CheckboxChangeEvent) => {
    onChange(checked, field);
  };

  return <Checkbox checked={!!field.value} onChange={handleOnChange} />;
};
